import React from "react";

import { useTheme } from "styled-components";

import { Box, ParagraphMd, SectionHeading } from "@olist/design-system";

export function FormHeader() {
  const theme = useTheme();
  return (
    <Box mb="32px">
      <SectionHeading mb="4px" color={theme.text?.primary} bold>
        Novo chamado de suporte
      </SectionHeading>
      <ParagraphMd color={theme.text?.secondary}>
        Somos um time dedicado em responder suas dúvidas e ajudar o seu negócio.
      </ParagraphMd>
    </Box>
  );
}
